var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "url-editor" }, [
    _c("h3", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "url-editor__input" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.url,
            expression: "url"
          }
        ],
        ref: "url",
        staticClass: "url-editor__textarea",
        attrs: { type: "text", placeholder: "URLを入力してください" },
        domProps: { value: _vm.url },
        on: {
          blur: _vm.emitInputText,
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.url = $event.target.value
            },
            _vm.onInputUrl
          ]
        }
      }),
      _vm._v(" "),
      _vm.isLoading || _vm.isSaving
        ? _c("div", { staticClass: "url-editor__loading" }, [
            _c("span", { staticClass: "el-icon-loading" })
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "url-editor__button button",
        attrs: { disabled: !_vm.canSubmit || _vm.isSaving },
        on: { click: _vm.submitChecker }
      },
      [_vm._v("\n    " + _vm._s(_vm.submitLabel) + "\n  ")]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "attention" }, [
      _vm._v(
        "※リンク先で見出し画像に設定されているファイルによっては、サムネイル画像が正しく表示されないことがあります。"
      )
    ]),
    _vm._v(" "),
    !_vm.isUrlValid && !_vm.isUrlEmpty
      ? _c("p", { staticClass: "url-editor__error" }, [
          _vm._v(
            "\n    URLを正しい形式で入力して下さい。(http://example.com/index.html)\n  "
          )
        ])
      : _vm.errorMessage
        ? _c("p", {
            staticClass: "url-editor__error",
            domProps: { innerHTML: _vm._s(_vm.errorMessage) }
          })
        : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "url-editor__close close-button",
        on: { click: _vm.close }
      },
      [_vm._v("×")]
    ),
    _vm._v(" "),
    _vm.statusCode
      ? _c("img", {
          staticClass: "url-editor__webBeacon",
          attrs: { src: _vm.webBeacon() }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "notice" }, [
      _c("li", [_vm._v("URLの埋め込みリンクを作成します。")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }